import PageMeta from "../../components/common/PageMeta";
import PageContainer from "../../components/common/PageContainer";
import PageHeader from "../../components/common/PageHeader";
import RdrNoticesSettings from "./RdrNoticesSettings";

export default function RdrNoticesSettingsPage() {
  return (
    <div>
      <PageMeta
        title="Chargemont | Verifi Notices Settings"
        description="Chargemont | Verifi Notices Settings"
      />
      <PageContainer>
        <PageHeader title="Verifi Notices Settings" />
        <RdrNoticesSettings />
      </PageContainer>
    </div>
  );
}
